
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'

const state = {
  paginationInfo: {
    total: 0,
    currentPage: 1,
    totalPages: 0,
    pageSize: DEFAULT_PAGE_SIZE
  },
  selectedUserForCommunication: [],
  currentPage: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  sort: null,
  order: null,
  filters: [],
  masterFilters: {
    date_from: '',
    date_to: '',
    date_download_from: '',
    date_download_to: '',
    type: '',
    location: '',
    status: '',
    subject: '',
    id_int: '',
    full_text: ''
  },
  notUseLikeTags: ['results', 'page', 'sort', 'order']
}

const getters = {
  getSelectedUserIdsForCommunication: state => {
    const _temp = []
    state.selectedUserForCommunication.forEach(element => {
      _temp.push(element.id)
    })
    return _temp
  },
  getSelectUsersForCommunicationBy: (state) => (property = 'email') => {
    const _temp = []
    state.selectedUserForCommunication.forEach(function (element) {
      _temp.push(element[property])
    })
    return _temp
  },
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value])
        /*
        if (Array.isArray(item)) {
          _.each(item, (item2, key2) => {
            const _temp = Object.keys(item2)[0]
            if (state.notUseLikeTags.indexOf(_temp) === -1) {
              tags.push([key + '.' + _temp, Object.values(item2)[0]])
            }
          })
        } else {
          tags.push([key, item])
        }
        */
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
      /*
      if (typeof item[1] === 'object' && item[1].value !== '') {
        data[item[0]] = []
        _.each(Object.entries(item[1]), (item2) => {
          if (item2[1] !== '') {
            const _makeParam = {}
            _makeParam[item2[0]] = item2[1]
            data[item[0]].push(_makeParam)
          }
        })
        if (_.isEmpty(data[item[0]])) delete (data[item[0]])
      }
      */
    })
    state.filters = data
    return data
  }
}

const mutations = {
  resetSelectedUserForCommunication (state) {
    state.selectedUserForCommunication = []
  },
  setSelectedUserForCommunication (state, data) {
    state.selectedUserForCommunication = data
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      date_from: '',
      date_to: '',
      date_download_from: '',
      date_download_to: '',
      type: '',
      location: '',
      status: '',
      subject: '',
      id_int: '',
      full_text: ''
    }
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
